export const selectSantanderClabe = state => state.santanderClabe;
export const selectSantanderClabeList = state =>
  selectSantanderClabe(state).items;
export const selectSantanderClabeCount = state =>
  selectSantanderClabe(state).count;
export const selectSantanderClabeQueryOptions = state => {
  const { options } = selectSantanderClabe(state);

  Object.keys(options).forEach(key => {
    if (options[key] === '') {
      delete options[key];
    }
  });

  return options;
};
export const selectSantanderClabeLoading = state =>
  selectSantanderClabe(state).loading;
export const selectSantanderClabeSuccess = state =>
  selectSantanderClabe(state).success;
export const selectSantanderPaymentDetails = state =>
  selectSantanderClabe(state).paymentDetails;
export const selectSantanderPaymentDetailsCount = state =>
  selectSantanderClabe(state).paymentDetailsCount;